class Factory {
  constructor(options={}) {
    for (var k in options) {
      this[k] = options[k];
    }
  }
}

if(typeof module !== 'undefined' && module.exports)
  module.exports = Factory;
else if(typeof window !== 'undefined')
  window.Factory = Factory;
